import client from './client';
import { EnCryptData, DeCryptData } from '../util/CustomUtil';

// 브랜드 가져오기 
export const getBrandListByCateId = ({ cateItems }) => {
    let params = new URLSearchParams();
    params.append('cate_id_list', cateItems);
    return client.post('/brand', params);
}

//브랜드관 ㄱ,A, 0-9 정보 가져오기
export const getBrandStat = () => {
    return client.get('/brand/stat');
}

//브랜드관 브랜드 정보 리스트 가져오기 (입접 브랜드)
export const getBrandInfo = ({ data, type, offset = 0 }) => {

    let urlString = "/brand/info?data=" + data + "&type=" + type + "&offset=" + offset;

    // console.log("getBrandInfo = " + urlString);
    var ua = navigator.userAgent.toLocaleLowerCase();
    var is_ie = ua.indexOf("msie ") > -1 || ua.indexOf("trident/") > -1;
    let _strUrl = urlString
    if(is_ie) {
        _strUrl = encodeURI(urlString)
    }

    return client.get(_strUrl);
}

//브랜드관 브랜드 정보 리스트 가져오기 (브랜드가 없다면)
export const getNoBrandInfo = ({ offset = 0 }) => {

    let urlString = "/brand/no?offset=" + offset;

    // console.log("getNoBrandInfo = " + urlString);
    return client.get(urlString);
}

//브랜드 홈 브랜드 정보 가져오기
export const getBrandHomeInfo = ({ brandId }) => {
    let urlString = "/brand?brandid=" + brandId;
    // console.log("getBrandHomeInfo = " + urlString);
    return client.get(urlString);
}

// 브랜드 클립 추가
export const brandAdd = ({ email, brandid }) => {
    // console.log("brandAdd Called !!! ")
    let paramdata = { email, brandid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/brand/add', params);
}

//브랜드 클립 제거
export const brandDel = ({ email, brandid }) => {
    // console.log("brandDel Called !!!")
    let paramdata = { email, brandid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/brand/del', params);
}

export const nobrandAdd = ({ email, nobrandid }) => {
    // console.log("nobrandAdd Called !!! ")
    let paramdata = { email, nobrandid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/nobrand/add', params);
}

export const nobrandDel = ({ email, brandid }) => {
    // console.log("nobrandDel Called !!!")
    let paramdata = { email, brandid };
    let params = new URLSearchParams();
    params.append('data', EnCryptData(JSON.stringify(paramdata)));
    return client.post('/user/nobrand/del', params);
}

// 브랜드 
export const getMainList = () => client.get('/brand/main');
export const allDelBrand = () => client.get('/user/brand/alldel');
export const allDelNoBrand = () => client.get('/user/nobrand/alldel')